// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resonator-stats-wrapper{height:100%;width:100%}.resonator-stats-wrapper .resonator-stats-chart{margin-bottom:36px}.resonatorStats_title{display:flex;align-items:center;padding:10px;margin-bottom:20px;height:65px}.resonatorStats_title>div{margin-left:15px}.MuiPaper-root{border-top:1px solid silver}\n", ""]);
// Exports
module.exports = exports;
